import { styled } from '@vw-marketing/us-components';

export const StyledFilterAttributeWrapper: any = styled.div<any>`
  ${({ isDisabled, highlight }) => `
  width: 100%;

  label span {
    ${isDisabled ? `color: #6a767d;` : ''}
    ${highlight ? `font-weight: bold;` : ''}
  }
`}
`;
